import { StylesConfig } from "react-select";

import { useTheme } from "../../../../context/theme";
import {
  typographyBodyLineHeightMap,
  typographyBodySizeMap
} from "../../../../styles/typography/typography";
import { useGetDropdownStyles } from "../../Dropdown";
import { Option, OptionGroup } from "../types";

export default function useCustomStyles(): StylesConfig<
  Option,
  true,
  OptionGroup
> {
  const styles = useGetDropdownStyles<Option, true, OptionGroup>({
    // Need to update custom components to support errors and other sizes
    size: "small",
    error: false
  });
  const theme = useTheme();

  return {
    ...styles,
    control: (provided: any) => ({
      ...provided,
      display: "none"
    }),
    menu: (provided: any) => ({
      ...provided,
      marginTop: "0px"
    }),
    menuList: (provided: any) => ({
      ...provided,
      backgroundColor: theme.foreground,
      color: theme["neutral-high-content"]
    }),
    groupHeading: (provided: any) => ({
      ...provided,
      color: theme["neutral-high-content"],
      textTransform: "none",
      ...typographyBodySizeMap.medium,
      ...typographyBodyLineHeightMap.large
    })
  };
}
